module.exports = __webpack_public_path__ + "static/img/one.1dd8d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/17/one.png
// module id = P8g3
// module chunks = 1